import dayjs from 'dayjs';
import { useMemo } from 'react';

import { compareItems } from '../../../utils';
import generateNumbersRange from '../../../utils/number/generateNumbersRange';
import { DropdownOption } from '../../Dropdown';

type Props = {
  minDate: string;
  maxDate: string;
};

const useYearOptions = ({ minDate, maxDate }: Props): DropdownOption[] =>
  useMemo(() => {
    const minYear = dayjs(minDate).year();
    const maxYear = dayjs(maxDate).year();

    const yearsRange = generateNumbersRange(minYear, maxYear);

    yearsRange.sort((a, b) => compareItems(a, b, 'desc'));

    return yearsRange.map<DropdownOption>(year => ({
      value: year.toString(),
      label: year.toString(),
    }));
  }, [minDate, maxDate]);

export default useYearOptions;
